class TimerEvent {

	get ADD_TIME() { return 'addTime'; }
	get PAUSE() { return 'pause'; }
	get PLAY() { return 'play'; }
	get SEEK() { return 'seek'; }
	get POLL_STATUS() { return 'pollStatus'; }
	get CHANGE() { return 'change'; }

}

export default new TimerEvent();
